import { message } from "antd";
import { authHeader } from "../../../../helpers/auth-header";
import { client } from "../../../../actions";
import uri from "../../constants/uri";
import actions from "../actions/actions";

const getNoticesPreview = (fileId) => async (dispatch) => {	
	try {
		dispatch({ type: actions.LIST_LOADING });
		const response = await client.get(`${uri}/notifications_preview`, {
			params: { fileId },
			headers: authHeader(),
		});
		dispatch({
			type: actions.NOTIFICATION_LIST_LOADED,
			payload: { notices: response.data },
		});
	} catch (error) {
		console.error(error);
		message.error("Не получилось загрузить оповещения");
		dispatch({
			type: actions.NOTIFICATION_LIST_LOADED,
		});
	}
};

export default getNoticesPreview;
